import _ from 'lodash';
import {
  GET_ONE_PATIENT,
  GET_PAST_INSURANCE,
  GET_PATIENT_ATTACHMENTS,
  GET_PATIENTS, GET_PATIENTS_NODE, SEND_INSURANCE_FILE, UPDATE_PATIENT,
} from '../actions/patients';
import { insuranceTemplate } from '../../utils/data/data';

const initialState = {
  patientList: [],
  currentPage: 0,
  pageCount: 0,
  patient: {},
  pastInsurance: {},
  patientAttachments: [],
  patientNodeList: [],
  requestStatus: '',
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PATIENTS.SUCCESS: {
      const { currentPage, pageCount } = payload.data.data._meta;

      return {
        ...state,
        patientList: payload.data.data.response,
        currentPage,
        pageCount,
      };
    }

    case GET_ONE_PATIENT.SUCCESS: {
      return {
        ...state,
        patient: payload.data.data.response[0],
      };
    }

    case UPDATE_PATIENT.SUCCESS: {
      const newPatient = { ...state.patient };

      insuranceTemplate.forEach(({ path, backPath }) => {
        _.set(newPatient, `Prim[${backPath}]`, payload[`prim${path}`]);
        _.set(newPatient, `Sec[${backPath}]`, payload[`sec${path}`]);
      });

      return {
        ...state,
        patient: newPatient,
      };
    }

    case SEND_INSURANCE_FILE.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
      };
    }

    case GET_PAST_INSURANCE.SUCCESS: {
      return {
        ...state,
        pastInsurance: payload.data.response[0],
      };
    }

    case GET_PATIENT_ATTACHMENTS.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
        patientAttachments: [],
      };
    }

    case GET_PATIENT_ATTACHMENTS.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        patientAttachments: payload.data.response,
      };
    }

    case GET_PATIENT_ATTACHMENTS.FAIL: {
      return {
        ...state,
        requestStatus: 'fail',
      };
    }

    case GET_PATIENTS_NODE.REQUEST: {
      return {
        ...state,
        requestStatus: 'request',
        patientNodeList: [],
      };
    }

    case GET_PATIENTS_NODE.SUCCESS: {
      return {
        ...state,
        requestStatus: 'success',
        patientNodeList: payload.data.response,
      };
    }

    case GET_PATIENTS_NODE.FAIL: {
      return {
        ...state,
        requestStatus: 'fail',
      };
    }
    default:
      return state;
  }
};

export default reducer;
